import { Snackbar, Typography, IconButton, Slide } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { ErrorIcon, SuccessIcon } from '../../Icons';

const iconStyle = {
    padding: '4px',
    borderRadius: '8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
};

const messageStyle = {
    width: '100%',
    display: 'flex',
    alignItems: 'flex-start', 
    justifyContent: 'flex-start',
    gap: 8,
    padding: '4px 0' 
};

const background = {
    'en': {
        'success': 'linear-gradient(to right, #22C55E88, transparent 50%)',
        'info': 'linear-gradient(to right, #3F77B088, transparent 50%)',
        'error': 'linear-gradient(to right, #FF4B4E88, transparent 50%)'
    },
    'ar': {
        'success': 'linear-gradient(to left, #22C55E88, transparent 50%)',
        'info': 'linear-gradient(to left, #3F77B088, transparent 50%)',
        'error': 'linear-gradient(to left, #FF4B4E88, transparent 50%)'
    }
};

const color = {
    'light-theme': '#111827',
    'dark-theme': '#FFF'
};

const backgroundColor = {
    'light-theme': '#EEF1F4',
    'dark-theme': '#0B1220'
};

const Alert = ({ theme, lang, type, position, message, open, close }) => (
    <Snackbar
        sx={{
            backgroundColor: backgroundColor[theme],
            borderRadius: '8px',
            '& .MuiPaper-root': {
                display: 'flex',
                borderRadius: 'inherit',
                alignItems: 'center',
                justifyContent: 'space-between',
                background: background[lang]?.[type] ?? 'transparent',
                color: color[theme],
                direction: lang === 'en' ? 'ltr' : 'rtl'
            },
            '& .MuiSnackbarContent-action': {
                paddingLeft: 0,
                margin: 0,
                marginRight: `${lang === 'en' ? '-' : ''}8px`
            },
            '& .MuiSnackbarContent-message': {
                flexGrow: 1,
                padding: '8px',
            }
        }}
        anchorOrigin={{ vertical: 'top', horizontal: position }}
        autoHideDuration={5000}
        open={open}
        onClose={close}
        TransitionComponent={Slide}
        TransitionProps={{ direction: position === 'left' ? 'right' : 'left' }}
        transitionDuration={400}
        message={
            <div style={messageStyle}>
                {type === 'success'
                    ? <div style={{ ...iconStyle, backgroundColor: backgroundColor[theme] }}>
                        <SuccessIcon />
                    </div>
                    : type === 'info'
                        ? <div style={{ ...iconStyle, backgroundColor: backgroundColor[theme] }}>
                            <ErrorIcon color={'#3F77B0'} />
                        </div>
                        : type === 'error'
                            ? <div style={{ ...iconStyle, backgroundColor: backgroundColor[theme] }}>
                                <ErrorIcon />
                            </div>
                            : null}
                <Typography variant='body1' component='p' sx={{
                    unicodeBidi: 'plaintext',
                    whiteSpace: 'pre-line', 
                    wordBreak: 'break-word', 
                    lineHeight: '1.7rem', 
                    textAlign: lang === 'en' ? 'left' : 'right',
                    fontSize:'1.2rem'
                }}>{message}</Typography>
            </div>
        } action={
            <IconButton style={{ color: '#7D8188' }} onClick={close}>
                <CloseIcon />
            </IconButton>
        } />
);

export default Alert;